import * as React from 'react';
import classnames from 'classnames';
import { Summary, DateTime, Price } from '@grandvisionhq/common';
import { Hr, Label } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import DetailHeader from '../../../components/DetailHeader/DetailHeader.js';

const TotalPrice = ({ label , totalPrice  })=>/*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement("span", null, label, " "), /*#__PURE__*/ React.createElement(Price, {
        value: totalPrice.amount,
        currency: totalPrice.currency
    }))
;
const SubscriptionHeader = ({ expiryDate , totalPrice , className , deliveryFrequency , disabled , nextDelivery , status ,  })=>{
    const { getLabel , locale  } = useIntl();
    const isExpired = status === 'EXPIRED';
    const deliveryFrequencyLabel = getDeliveryFrequencyLabel(deliveryFrequency, getLabel);
    const durationDefinition = isExpired ? `2 ${getLabel('common.duration.years')} - ${getLabel(`account.subscription.status.expired`)}` : `2 ${getLabel('common.duration.years')}`;
    return /*#__PURE__*/ React.createElement(Summary, {
        className: classnames('subscription-header subscription__summary', className, {
            'subscription-header--disabled': disabled
        })
    }, /*#__PURE__*/ React.createElement(DetailHeader, {
        className: "subscription-header__info"
    }, /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: getLabel('account.subscription.length') + ': ',
        definition: durationDefinition
    }), deliveryFrequency && /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: getLabel('account.subscription.deliveryFrequency') + ': ',
        definition: deliveryFrequencyLabel
    }), /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: getLabel('account.subscription.nextDelivery') + ': ',
        definition: nextDelivery ? /*#__PURE__*/ React.createElement(DateTime, {
            dateTime: new Date(nextDelivery.date),
            locale: locale
        }) : getLabel('account.subscription.nextDelivery.unavailable')
    }), /*#__PURE__*/ React.createElement(DetailHeader.Item, {
        term: /*#__PURE__*/ React.createElement(TotalPrice, {
            label: getLabel('common.total') + ': ',
            totalPrice: totalPrice
        }),
        definition: getLabel('common.frequency.perMonth')
    })), /*#__PURE__*/ React.createElement(Hr, {
        className: "subscription-header__horizontal-rule"
    }), !isExpired && /*#__PURE__*/ React.createElement(Label, {
        type: "neutral"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, getLabel(`account.subscription.expiryDate`) + ': ', /*#__PURE__*/ React.createElement(DateTime, {
        dateTime: expiryDate,
        locale: locale
    }))));
};
function getDeliveryFrequencyLabel(label, getLabel) {
    if (!label) {
        return undefined;
    }
    switch(label){
        case 'ANNUALLY':
            return getLabel('common.frequency.yearly');
        case 'BI_WEEKLY':
            return getLabel('common.frequency.biweekly');
        default:
            return getLabel(`common.frequency.${label.toLowerCase()}`);
    }
}
var SubscriptionHeader$1 = SubscriptionHeader;

export { SubscriptionHeader$1 as default, getDeliveryFrequencyLabel };
//# sourceMappingURL=SubscriptionHeader.js.map
